import React, { Component } from 'react'
import Axios from 'axios'

import { Row, Col } from '../../../SPRINTA/atoms/Grid'
import Button from '../../../SPRINTA/atoms/Button'
import Loading from '../../../SPRINTA/atoms/Loading'
import { Text } from '../../../SPRINTA/atoms/Forms'


export default class ContactForm extends Component {
    state = {
        errorContact: null,
        successContact: null,
        contactIsLoading: false,
        nameContact: '',
        emailContact: '',
        phoneContact: '',
        companyContact: ''
    }

    handleSubmitContact(e) {
      e.preventDefault()
      e.stopPropagation()
      var name = this.state.nameContact
      var email = this.state.emailContact
      var phone = this.state.phoneContact
      var company = this.state.companyContact

      this.setState({
        errorContact: null,
        successContact: null,
      })

      if(name === "") {
        this.setState({
          errorContact: 'Preencha o campo nome'
        })
        return
      }

      if(email === "") {
        this.setState({
          errorContact: 'Preencha o campo e-mail'
        })
        return
      }

      if(phone === "") {
        this.setState({
          errorContact: 'Preencha o campo telefone'
        })
        return
      }

      this.setState({
          contactIsLoading: true
        })
        
        
        Axios.post('/lead/save', { name: this.state.nameContact, email: this.state.emailContact, phone: this.state.phoneContact })
        .then(resp => {
            this.setState({
                successContact: "Contato salvo com sucesso!",
                contactIsLoading: false,
                nameContact: '',
                emailContact: '',
                phoneContact: '',
                companyContact: ''
            })
        })
    }

    render() {
        return (
            <form onSubmit={(e) => this.handleSubmitContact(e)}>
              <h1 style={{fontSize: '3em'}}><b>Converse conosco</b> sobre<br />todas suas dúvidas</h1>

              { this.state.errorContact && (
                <p style={{ color: 'red', fontSize: '14px', marginBottom: '20px' }}> {this.state.errorContact} </p>
              ) }

              { this.state.successContact && (
                <p style={{ color: 'green', fontSize: '14px', marginBottom: '20px' }}> {this.state.successContact} </p>
              ) }

              <Col size="12 6" float='center'>
                <Row>
                  <Col size="12 6" float='center'>
                    <Text placeholder="Nome" value={this.state.nameContact} handleChange={(e) => {
                                                        this.setState({
                                                          nameContact: e.target.value
                                                        })
                                                    }} style={{margin:'0 0 20px 0'}}/>
                    <Text placeholder="E-mail" value={this.state.emailContact} handleChange={(e) => {
                                                        this.setState({
                                                          emailContact: e.target.value
                                                        })
                                                    }} style={{margin:'0 0 20px 0'}}/>
                    <Text placeholder="Telefone" value={this.state.phoneContact} handleChange={(e) => {
                                                        this.setState({
                                                          phoneContact: e.target.value
                                                        })
                                                    }} style={{margin:'0 0 20px 0'}} />
                  </Col>
                </Row>
                 <Button inline theme="primary">{this.state.contactIsLoading ? <Loading color='#fff' size='30px' /> : 'Solicitar contato'}</Button>
              </Col>
            </form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App/Components/ContactForm/index.js